<template>
  <div class="gateway">
    <div class="filter-container">
      <el-input size="medium" placeholder="Gateway ID" v-model="search" clearable debounce @input="changeInput()"
        :style="{ width: '300px', marginRight: '20px' }" />
      <el-button size="medium" type="primary" @click="handleSearch()">Search</el-button>
    </div>

    <el-table :data="list.slice(
      (listQuery.page - 1) * listQuery.limit,
      listQuery.page * listQuery.limit
    )
      " v-loading="listLoading" style="width: 100%;" :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="S/N">
        <template slot-scope="{ row, $index }">
          <span>{{$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="idle" label="Idle">
        <template slot-scope="{ row, $index }">
          <span :class="['status', row.idle ? 'idle' : '']"></span>
        </template>
      </el-table-column>
      <el-table-column prop="gateway_id" label="Gateway ID"></el-table-column>
      
      <el-table-column label="Action">
        <template slot="header" slot-scope="scope">
          <i class="el-icon-circle-plus addUser" @click="handleCreate"> </i>
        </template>

        <template slot-scope="{ row, $index }">
         
          <el-popconfirm title="Do you want to delete the gateway?" confirm-button-text="Yes" cancel-button-text="No"
            @onConfirm="handleDelete(row)">
            <i slot="reference" class="el-icon-delete delUser"> </i>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="ls-page">
      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
        @pagination="getDataList" />
    </div>

    <el-dialog :title="dialogStatus" :visible.sync="dialogFormVisible" @close="resetForm" width="40%">
      <el-form ref="userForm" :rules="rules" :model="temp" label-position="left" label-width="100px" class="userForm">
        <el-form-item label="Gateway ID" prop="gateway_id">
          <el-input v-model="temp.gateway_id" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          Cancel
        </el-button>
        <el-button type="primary" @click="createData()">
          Submit
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "components/pagination";

import { getGatewayList, createGateway, deleteGateway } from "network/device";

export default {
  name: "Gateway",
  components: { Pagination },
  data() {
    return {
      search: "",
      type: "",
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
      },
      list: [],
      temp: {
        gateway_id: ""
      },
      dialogFormVisible: false,
      dialogStatus: "",
      rules: {
        gateway_id: [
          {
            required: true,
            message: "Please input gateway id.",
            trigger: "blur",
          },
        ]
      }
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      this.listLoading = false;
      getGatewayList()
        .then((data) => {
          this.listLoading = false;

          this.list = data.data;
          this.total = this.list.length;
        })
        .catch((err) => {
          this.$message.error("Interface error: get_gateway_list");
        });
    },
    changeInput() {
      if (this.search === "") {
        this.getDataList();
      }
    },
    handleSearch() {
      this.listLoading = false;
      getGatewayList()
        .then((data) => {
          if (data.status === 200) {
            this.listLoading = false;

            this.list = data.data;
            this.total = this.list.length;
          }
        })
        .then(() => {
          let newList = [];
          newList = this.list.filter((item, index) => {
            const gateway =
              item.gateway_id.toUpperCase().indexOf(this.search.toUpperCase()) !==
              -1;

            if (gateway) {
              return true;
            }
          });

          this.list = newList;
          this.total = newList.length;
        })
        .catch((err) => {
          this.$message.error("Interface error: get_sensor_list");
        });
    },
    resetForm() {
      this.temp = {
        gateway_id: ""
      };
      this.$nextTick(() => {
        if (this.$refs["userForm"]) {
          this.$refs["userForm"].clearValidate();
        }
      });
    },
    handleCreate() {
      this.dialogStatus = "Create";
      this.dialogFormVisible = true;
    },
    createData() {
      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          createGateway(this.temp).then((data) => {
            console.log(data);
            if (data.status === 201) {
              this.getDataList();

              this.dialogFormVisible = false;

              this.$message({
                message: "Created Successfully.",
                type: "success",
              });
            }
          })
          .catch(err => {
            this.$message.error("Interface error: this gateway id already exists.");
          })
        }
      });
    },
    handleDelete(row) {
      deleteGateway(row.id).then((data) => {
        if (data.status === 204) {
          this.getDataList();

          this.$message({
            message: "Delete Successfully.",
            type: "success",
          });
        }
      })
      .catch(err => {
        this.$message.error("Interface error: delete gateway");
      })
    },
  },
};
</script>

<style scoped>
.gateway .status {
  display: block;
  margin: 0 auto;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: red;
}
.gateway .status.idle{
  background-color: green;
}
.ls-page {
  float: right;
}

.addUser {
  font-size: 32px;
  cursor: pointer;
}

.editUser {
  font-size: 28px;
  cursor: pointer;
}

.delUser {
  /* margin-left: 10px; */
  font-size: 28px;
  cursor: pointer;
  color: red;
}

.userForm .el-select {
  width: 100%;
}
</style>
